import React from 'react';
import YouTube from 'react-youtube';
import LazyDiv from '../lazy/lazydiv';
import "./full.css";


const YoutubeFullPlayer = (props) => {


    

    const opts = props.playlistId?
    {
        height: '90vh',
        width: '100vw',
        playerVars: {
          // https://developers.google.com/youtube/player_parameters
          autoplay: 1,
          listType:"playlist",
          list:props.playlistId
        },
      }
      :
      {
        height: '90vh',
        width: '100vw',
        playerVars: {
          // https://developers.google.com/youtube/player_parameters
          autoplay: 1
          // listType:"playlist",
          // list:"PLNI-cJa63vBJPJHPmUo3EBlsHNdMABQ3S"
        },
      }
    return (
        <LazyDiv orient={"landscape"} className={"youtubeFull"}>
            <YouTube videoId={props.videoId} opts={opts} loading={"lazy"} />
        </LazyDiv>
    );
};

export default YoutubeFullPlayer;